import { registerCapability } from '../../platform/capability-registry';
import { PowerPolicyBlock } from './PowerPolicyBlock';
import { POWER_POLICY_FIELD_KEY_LIST } from './fieldKeys';
import { resolvePowerPolicyPaths } from './resolvePaths';
import type { PowerPolicyBlockOptions } from './types';

registerCapability<PowerPolicyBlockOptions>({
  key: 'power-policy',
  fields: [...POWER_POLICY_FIELD_KEY_LIST],
  component: PowerPolicyBlock,
  defaultPaths: (prefix) => resolvePowerPolicyPaths(prefix),
  resolvePaths: (prefix, options) => resolvePowerPolicyPaths(prefix, options),
});
